import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';
import type {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

interface ParagraphArticlesFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphArticlesFiltered: React.FC<ParagraphArticlesFilteredProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphArticlesFiltered">
      <Container>
        <h2 className="visually-hidden">{t('content_types.article.subheading')}</h2>
        <View
          className="row"
          id="articles_filtered"
          display="articles_filtered"
          storageType="url"
          withProvider
        />
      </Container>
    </div>
  );
};

export default ParagraphArticlesFiltered;
